import { BookOpen } from 'lucide-react';
import { PageLayout } from '@/components/layout/PageLayout';
import { SkillLibrary } from '@/components/skill';

/**
 * Skill Library page — top-level entry point for the unified skill catalog.
 * Reachable from the sidebar at /skills. The Skill Library is also embedded
 * at the bottom of the Agentic Orchestration Center (/agentic-orchestration).
 */
export function SkillLibraryPage() {
  return (
    <PageLayout
      title="Skill Library"
      description="Every agent capability exposed by the Khiimori platform. Run any skill in one click, or open its dedicated page."
      icon={BookOpen}
    >
      <SkillLibrary
        title="Available Skills"
        description="Browse by category, search by name, or run a skill directly."
        columns={3}
      />
    </PageLayout>
  );
}

export default SkillLibraryPage;
